import { getCurrentInstance as r, computed as u } from "vue";
let c = 0;
function s(t = "kori", n) {
  const e = r(), o = `${t}-${e?.uid ?? ++c}`;
  return u(() => n ?? o);
}
export {
  s as u
};
//# sourceMappingURL=useId-DuhnX31i.js.map
